/* product-zoom.js
 * NuveRise — premium PDP image zoom.
 * Desktop: hover-lens + zoomed pane.
 * Mobile:  tap → full-screen lightbox with pinch-zoom + swipe navigation.
 */
(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 769;
  var LENS_SIZE = 120;

  function init() {
    document.querySelectorAll('[data-pz]').forEach(initZoom);
  }

  function initZoom(root) {
    var main         = root.querySelector('[data-pz-main]');
    var img          = root.querySelector('.pz-img');
    var lens         = root.querySelector('[data-pz-lens]');
    var zoom         = root.querySelector('[data-pz-zoom]');
    var lightbox     = root.querySelector('[data-pz-lightbox]');
    var lightboxImg  = root.querySelector('[data-pz-lightbox-img]');
    var closeBtn     = root.querySelector('[data-pz-lightbox-close]');
    var expandBtn    = root.querySelector('[data-pz-expand]');
    if (!main || !img || !lens || !zoom) return;

    var zoomSrc = img.dataset.zoomSrc || img.src;
    setZoomBackground(zoom, zoomSrc);

    // Preload the high-res zoom image so background-position pans feel buttery
    preload(zoomSrc);

    // --- Desktop hover zoom -----------------------------------------------
    function onEnter() {
      if (window.innerWidth < DESKTOP_BREAKPOINT) return;
      main.classList.add('is-zooming');
    }
    function onLeave() {
      main.classList.remove('is-zooming');
    }
    function onMove(e) {
      if (window.innerWidth < DESKTOP_BREAKPOINT) return;
      var rect = main.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) return;

      var px = (x / rect.width) * 100;
      var py = (y / rect.height) * 100;

      // Lens clamped inside frame
      var lx = Math.max(0, Math.min(rect.width  - LENS_SIZE, x - LENS_SIZE / 2));
      var ly = Math.max(0, Math.min(rect.height - LENS_SIZE, y - LENS_SIZE / 2));
      lens.style.left = lx + 'px';
      lens.style.top  = ly + 'px';
      zoom.style.backgroundPosition = px + '% ' + py + '%';
    }
    main.addEventListener('mouseenter', onEnter);
    main.addEventListener('mouseleave', onLeave);
    main.addEventListener('mousemove', onMove);

    // --- Lightbox open/close ----------------------------------------------
    function openLightbox() {
      if (!lightbox || !lightboxImg) return;
      lightboxImg.src = zoomSrc;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }
    if (expandBtn) expandBtn.addEventListener('click', openLightbox);

    // Mobile tap on the image opens lightbox; suppress click if it followed a drag/scroll
    var touchMoved = false;
    img.addEventListener('touchstart', function () { touchMoved = false; }, { passive: true });
    img.addEventListener('touchmove',  function () { touchMoved = true;  }, { passive: true });
    img.addEventListener('click', function () {
      if (touchMoved) return;
      if (window.innerWidth < DESKTOP_BREAKPOINT) openLightbox();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
    });

    // Backdrop click closes (but not when clicking the image itself)
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }

    // --- Thumbnails -------------------------------------------------------
    var thumbs = root.querySelectorAll('[data-pz-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('pz-thumb--active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.classList.add('pz-thumb--active');
        thumb.setAttribute('aria-selected', 'true');

        var newMain = thumb.dataset.imgSrc;
        var newZoom = thumb.dataset.zoomSrc;
        if (newMain) {
          img.src = newMain;
          img.dataset.zoomSrc = newZoom || newMain;
        }
        if (newZoom) {
          zoomSrc = newZoom;
          setZoomBackground(zoom, zoomSrc);
          preload(zoomSrc);
          if (lightbox && !lightbox.hidden && lightboxImg) lightboxImg.src = zoomSrc;
        }
      });
    });

    // --- Lightbox swipe to navigate ---------------------------------------
    if (lightbox && thumbs.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      lightbox.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;

        // Swipe down → close (must be clearly vertical)
        if (dy > 80 && Math.abs(dy) > Math.abs(dx) * 1.5) {
          closeLightbox();
          return;
        }
        // Horizontal swipe → navigate (must clear threshold + be clearly horizontal)
        if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.2) return;

        var arr = Array.prototype.slice.call(thumbs);
        var current = arr.findIndex(function (t) { return t.dataset.zoomSrc === zoomSrc; });
        if (current < 0) return;
        var next = dx > 0 ? current - 1 : current + 1;
        if (next < 0) next = arr.length - 1;
        if (next >= arr.length) next = 0;
        arr[next].click();
      }, { passive: true });
    }
  }

  function setZoomBackground(zoom, src) {
    zoom.style.backgroundImage = "url('" + src + "')";
  }

  function preload(src) {
    if (!src) return;
    var i = new Image();
    i.src = src;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
